	<!-- isEditing -->
	@if (type() === 'string') {
		@let valueWithMetadata = chargerSettingService.returnStringSettingWithMetadata(value());
		@if (valueWithMetadata) {
			<mat-form-field appearance="outline" [style.width]="selectWidthFromOptions(valueWithMetadata.allowedValues)" style="margin-right: 6px;">
				<mat-select
					[(value)]="valueWithMetadata.value"
					(selectionChange)="saveProperty(valueWithMetadata)"
					[disabled]="!isChangeAllowed()"
					[class.error]="saveFailed()"
				>
					@for (option of valueWithMetadata.allowedValues; track option) {
						<mat-option [value]="option">{{ option | propertyOptionTranslate }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		}
	
	} @else if (type() === 'freeString') {
		@let valueWithMetadata = chargerSettingService.returnFreeStringSettingWithMetadata(value());
		@if (valueWithMetadata) {
			<mat-form-field appearance="outline" style="width: fit-content; min-width: 160px; margin-right: 6px;">
				<input
					matInput
					[type]="typeof valueWithMetadata.value"
					[value]="valueWithMetadata.value"
					(input)="valueWithMetadata.value = $any($event.target).value; updateFreeString()"
					[disabled]="!isChangeAllowed()"
					[class.error]="saveFailed()"
				/>
			</mat-form-field>
		}

	} @else if (type() === 'number') {
		@let valueWithMetadata = chargerSettingService.returnNumberSettingWithMetadata(value());
		@if (valueWithMetadata) {
			<div class="number-stepper" [class.disabled]="!isChangeAllowed()">
				<button
					type="button"
					class="stepper-btn"
					(click)="updateNumber(valueWithMetadata, -1)"
					[disabled]="!isChangeAllowed()"
				>−</button>

				<div class="stepper-value">
					{{ valueWithMetadata.value }}
				</div>

				<button
					type="button"
					class="stepper-btn"
					(click)="updateNumber(valueWithMetadata, +1)"
					[disabled]="!isChangeAllowed()"
				>+</button>
			</div>
			<div class="hint-end">
				{{ valueWithMetadata.lowerLimit }} – {{ valueWithMetadata.upperLimit }}
			</div>
		}

	} @else if (type() === 'boolean') {
		@let valueWithMetadata = chargerSettingService.returnBooleanSettingWithMetadata(value());
		@if (valueWithMetadata) {
			<mat-slide-toggle
				[checked]="valueWithMetadata.value"
				(change)="valueWithMetadata.value = $event.checked; saveProperty(valueWithMetadata)"
				[disabled]="!isChangeAllowed()"
				[class.error]="saveFailed()"
			>
			</mat-slide-toggle>
			<span> {{ valueWithMetadata.value | propertyBooleanTranslate }} </span>
		}

	} @else if (type() === 'DelayedStart') {
		@let valueWithMetadata = chargerSettingService.returnDelayedStartWithMetaData(value());
		@if (valueWithMetadata) {
			<input
				matInput
				[class.error]="saveFailed()"
				[type]="typeof valueWithMetadata.value.beginTimeHour.value"
				[min]="valueWithMetadata.value.beginTimeHour.lowerLimit"
				[max]="valueWithMetadata.value.beginTimeHour.upperLimit"
				[value]="valueWithMetadata.value.beginTimeHour.value | number: '2.0'"
				(input)="valueWithMetadata.value.beginTimeHour.value = +$any($event.target).value"
			/>
			<input
				matInput
				[class.error]="saveFailed()"
				[type]="typeof valueWithMetadata.value.beginTimeMinute.value"
				[min]="valueWithMetadata.value.beginTimeMinute.lowerLimit"
				[max]="valueWithMetadata.value.beginTimeMinute.upperLimit"
				[value]="valueWithMetadata.value.beginTimeMinute.value | number: '2.0'"
				(input)="valueWithMetadata.value.beginTimeMinute.value = +$any($event.target).value"
			/>
			<mat-form-field appearance="outline" style="width: 160px; margin-right: 6px;">
				<mat-select 
					[(value)]="valueWithMetadata.value.chargingMode.value"
					[class.error]="saveFailed()"
				>
					@for (option of valueWithMetadata.value.chargingMode.allowedValues; track option) {
						<mat-option [value]="option">{{ option }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
			<button 
				matIconButton
				[disabled]="!isChangeAllowed()"
				(click)="saveProperty(value())"
				matTooltip="Save"
			i18n-matTooltip="@@Save"
			>
				💾
			</button>
		}

	} @else if (type() === 'DaySchedule') {
		@let valueWithMetadata = chargerSettingService.returnDaySchedule(value());
		@if (valueWithMetadata) {
			@for (period of valueWithMetadata; track period; let i = $index) {
				<span i18n="@@From">From</span><br/>
				<mat-form-field appearance="outline" style="width: 70px">
					<input
						matInput
						[class.error]="saveFailed()"
						[type]="typeof period.beginTimeHour"
						[min]="0"
						[max]="23"
						[value]="period.beginTimeHour | number: '2.0'"
						(input)="period.beginTimeHour = +$any($event.target).value"
					/>
				</mat-form-field>
				:
				<mat-form-field appearance="outline" style="width: 70px">
					<input
						matInput
						[class.error]="saveFailed()"
						[type]="typeof period.beginTimeMinute"
						[min]="0"
						[max]="59"
						[value]="period.beginTimeMinute | number: '2.0'"
						(input)="period.beginTimeMinute = +$any($event.target).value"
					/>
				</mat-form-field>
				<br/>
				<span i18n="@@To">To</span><br/>
				<mat-form-field appearance="outline" style="width: 70px">
					<input
						matInput
						[class.error]="saveFailed()"
						[type]="typeof period.endTimeHour"
						[min]="0"
						[max]="23"
						[value]="period.endTimeHour | number: '2.0'"
						(input)="period.endTimeHour = +$any($event.target).value"
					/>
				</mat-form-field>
				:
				<mat-form-field appearance="outline" style="width: 70px">
					<input
						matInput
						[class.error]="saveFailed()"
						[type]="typeof period.endTimeMinute"
						[min]="0"
						[max]="59"
						[value]="period.endTimeMinute | number: '2.0'"
						(input)="period.endTimeMinute = +$any($event.target).value"
					/>
				</mat-form-field>
				<br/>
				<span i18n="@@Mode">Mode</span><br/>
				<mat-form-field appearance="outline" style="width: 160px">
					<mat-select 
						[(value)]="period.chargingMode"
						[class.error]="saveFailed()"
					>
						@for (option of metadata()?.allowedValues; track option) {
							<mat-option [value]="option">{{ option }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
				<br/>
				<button 
					matMiniFab
					[disabled]="!isChangeAllowed()"
					(click)="deleteDaySchedulePeriod(valueWithMetadata, i)"
					matTooltip="Delete day schedule period"
				i18n-matTooltip="@@DeleteDaySchedulePeriod"
				>
					<mat-icon>delete</mat-icon>
				</button>
				<br/>
				<br/>
				<mat-divider></mat-divider>
				<br/>
				@if (i < valueWithMetadata.length - 1) {
				}
			}
			<button 
				matMiniFab
				[disabled]="!isChangeAllowed() || valueWithMetadata.length >= 2"
				(click)="addDaySchedulePeriod(valueWithMetadata)"
				matTooltip="Add day schedule period"
			i18n-matTooltip="@@AddDaySchedulePeriod"
			>
				<mat-icon>add</mat-icon>
			</button>
			<button 
				matMiniFab
				[disabled]="!isChangeAllowed()"
				(click)="saveProperty(value())"
				matTooltip="Save day schedule"
				i18n-matTooltip="@@SaveDaySchedule"
				style="margin-left: 6px;"
			>
				<mat-icon>save</mat-icon>
			</button>
		}

	} @else if (type() === 'Cpms') {
		@let valueWithMetadata = chargerSettingService.returnCpmsWithMetaData(value());
		@if (valueWithMetadata && valueWithMetadata.value) {
			<mat-form-field appearance="outline" [style.width]="selectWidthFromCpms(valueWithMetadata.allowedValues)" style="margin-right: 6px;">
				<mat-select
					[value]="cpmsSelectValue()"
					(selectionChange)="onCpmsSelectionChange($event.value, valueWithMetadata)"
					[disabled]="!isChangeAllowed()"
					[class.error]="saveFailed()"
				>
					@for (option of valueWithMetadata.allowedValues; track option.name) {
						<mat-option [value]="option.name">{{ option.name }}</mat-option>
					}
					<mat-option value="__custom__" i18n="@@Custom">Custom</mat-option>
				</mat-select>
			</mat-form-field>
			@if (isCustomCpms()) {
				<br/>
				<mat-form-field appearance="outline" [style.width]="selectWidthFromCpms(valueWithMetadata.allowedValues)" style="margin-right: 6px;">
					<mat-label i18n="@@Name">Name</mat-label>
					<input matInput [value]="customCpmsName()" (input)="customCpmsName.set($any($event.target).value)" [disabled]="!isChangeAllowed()" />
				</mat-form-field>
				<br/>
				<mat-form-field appearance="outline" [style.width]="selectWidthFromCpms(valueWithMetadata.allowedValues)" style="margin-right: 6px;">
					<mat-label>Url</mat-label>
					<input matInput [value]="customCpmsUrl()" (input)="customCpmsUrl.set($any($event.target).value)" [disabled]="!isChangeAllowed()" />
				</mat-form-field>
				<button matButton="elevated" color="primary" (click)="saveCustomCpms(valueWithMetadata)" [disabled]="!isChangeAllowed()" i18n="@@Save">Save</button>
			}
		}
	
	} @else {
		<!-- unknown type -->
	}
